import { render, staticRenderFns } from "./UserDetail_IntrestedArea.vue?vue&type=template&id=ef7a2094&"
import script from "./UserDetail_IntrestedArea.vue?vue&type=script&lang=js&"
export * from "./UserDetail_IntrestedArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports